import MuiCloseOutlined from '@mui/icons-material/CloseOutlined';
import { SvgIconProps } from '@mui/material/SvgIcon';

export type CloseOutlinedProps = SvgIconProps;

export const CloseOutlined = (props: CloseOutlinedProps) => {
  return <MuiCloseOutlined {...props} />;
};
